<template>
  <form-field :attribute="attribute" type="radio" :label="label" :required="required" :errorKeys="errorKeys">
    <div class="radio-options">
      <slot></slot>
    </div>
  </form-field>
</template>

<script>
import ActsAsFormField from "../../mixins/ActsAsFormField";

export default {
  provide() {
    return {
      attribute: this.attribute,
    };
  },

  mixins: [ActsAsFormField],
};
</script>
